<template>
  <div>
    <br />
    <h2 class="ViewHeading">Maintenance Portal</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >

      <b-row> </b-row>
    </div>
    <div>
      <b-card>
        <b-tabs>
          <b-tab
            title="Commissions"
            lazy
            v-if="this.UserAccess.includes('CLA')"
          >
            <b-card>
              <b-tabs>
                <!-- <b-tab title="C-1" lazy>
                  <C1Comm></C1Comm>
                </b-tab>
                <b-tab title="O-1" lazy>
                  <O1Comm></O1Comm>
                </b-tab>
                <b-tab title="Hubs" lazy>
                  <HubComm></HubComm>
                </b-tab> -->
                <b-tab title="Device Commission">
                  <h5>Press button below to initiate Commission Wizard</h5>
                  <br/>
                   <b-button variant="outline-info"  v-on:click="showWizard()">Launch Commissioning Wizard</b-button>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-tab>
          <b-tab
            title="Calibration"
            v-if="this.UserAccess.includes('CLA')"
            lazy
          >
            <b-card>
              <b-tabs>
                <b-tab title="C-1" lazy>
                  <C1Calib></C1Calib>
                </b-tab>
                <b-tab title="O-1" lazy>
                  <O1Calib></O1Calib>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-tab>
          <b-tab
            title="Device Actions"
            v-if="this.UserAccess.includes('CLA')"
            lazy
          >
            <b-card>
              <b-tabs>
                <b-tab title="C-1 Actions">
                  <C1Actions></C1Actions>
                </b-tab>
                <b-tab title="O-1 Actions"> <O1Actions></O1Actions> </b-tab>
              </b-tabs>
            </b-card>
          </b-tab>
          <b-tab
            title="Water Management"
            v-if="this.UserAccess.includes('WM')"
            lazy
          >
            <b-card>
              <b-tabs>
                <b-tab title="Manual Temp Test" lazy>
                  <StartTempTest> </StartTempTest>
                </b-tab>
                <b-tab title="Water Test" lazy>
                  <StartWaterTest> </StartWaterTest>
                </b-tab>
    
              </b-tabs>
            </b-card>
          </b-tab>
          <b-tab title="Appointments" lazy>
            <b-tabs>
              <b-tab
                :title="'Scheduled Appointments for ' + this.selectedlocation"
              >
                <Scheduled> </Scheduled>
              </b-tab>
              <b-tab :title="'Scheduled Appointments for ' + this.fullname">
                <ScheduledUser> </ScheduledUser>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab title="Flush Tracking" lazy v-if="this.UserAccess.includes('CLA')">
            <b-tabs>
              <b-tab title="Flush Tracking">
                <FlowCheckInput />
              </b-tab>
            </b-tabs>
          </b-tab>
        </b-tabs>
      </b-card>
      <br />
    </div>
     <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="CalWizard"
            id="CalWizard"
            title="Device Calibrations"
            hide-footer>
            <b-card>
            <CALWizard @WizardComplete="FinishCALWizard" :Type="Type" :ID="ID"/>
            </b-card>

        </b-modal>
        <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="ComWizard"
            id="ComWizard"
            title="Device Commissioning"
            hide-footer>
            <b-card>
            <COMWizard @WizardComplete="FinishWizard" />
            </b-card>

        </b-modal>

  </div>
</template>

<script>
import C1Actions from "../components/ActionComponents/ActionsC1.vue";
import O1Actions from "../components/ActionComponents/ActionsO1.vue";
// import C1Comm from "../components/CommissionComponents/C1Comm.vue";
// import O1Comm from "../components/CommissionComponents/O1Comm.vue";
// import HubComm from "../components/CommissionComponents/HubComm.vue";
import COMWizard from "../components/CommissionWizard/COMWizard.vue";
import C1Calib from "../components/CalibrationComponents/CalibrationC1.vue";
import O1Calib from "../components/CalibrationComponents/CalibrationO1.vue";
import StartWaterTest from "../components/WmMaintenanceComponents/StartWaterTest.vue";
import StartTempTest from "../components/WmMaintenanceComponents/StartTempTest.vue";
import Scheduled from "../components/ScheduledLocation.vue";
import ScheduledUser from "../components/ScheduledUser.vue";

import FlowCheckInput from "../components/FlowCheckInput.vue";


export default {
  data() {
    return {
      selectedlocation: localStorage.getItem("location"),
      UserAccess: localStorage.getItem("accessGroup"),
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("profileportal"),
      fullname: localStorage.getItem("fullname"),
    };
  },

  components: {
    C1Actions,
    O1Actions,
    // C1Comm,
    // O1Comm,
    // HubComm,
    COMWizard,
    C1Calib,
    O1Calib,
    ScheduledUser,
    StartWaterTest,
    StartTempTest,
    Scheduled,
    FlowCheckInput,
  },
  methods: {
     showWizard(){
            this.$refs["ComWizard"].show();
        },
        FinishWizard(){
            this.$refs["ComWizard"].hide();
            console.log("Data has been submitted")
        },

  },
};
</script>
<style scoped></style>
